module.exports = __webpack_public_path__ + "img/img01.92c5b2bd.png";